import { useQuery } from "@tanstack/react-query";

import { captainQueryKeys } from "./query-keys";
import type { ConversationDetail } from "../types";

import { instance } from "@/lib/axios/instance";

export async function fetchConversation(
  conversationId: string,
): Promise<ConversationDetail> {
  const res = await instance.get<ConversationDetail>(
    `/api/v2/captain/conversations/${conversationId}`,
  );
  return res.data;
}

export function useConversation(conversationId: string | null) {
  return useQuery<ConversationDetail>({
    queryKey: captainQueryKeys.conversation(conversationId ?? ""),
    queryFn: () => fetchConversation(conversationId!),
    enabled: !!conversationId,
  });
}
